





































































































































































































































































































import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import {
  ClientStyleFormDTO,
} from '@/api';
import service from '@/services';
@Component({
  name: 'clients-navbar',
})
export default class RightBar extends Vue {
  @Prop(Number) userId?: number;

  form: ClientStyleFormDTO | null = null;

  @Watch('userId', { immediate: true })
  async loadForm(newValue: number) {
    if (newValue) {
      const { data } = await service.compilationsApi().compilationEndpointClientFormNew(newValue);
      this.form = data;
    }
  }
}
